export const fetchJson = (url, options) => fetch(url, options).then(res => {
  if (res.ok) {
    return res.json();
  }
  throw new Error(`HTTP ${res.status}: ${res.statusText}`);
});